import { useState } from 'react';

import { useForm } from 'react-hook-form';

import { useAssigneeOptionsList } from 'hooks/useAssigneeOptionsList';
import { useQueryState } from 'hooks/useQueryState';

import { useProjectTreeStore } from 'store/projectContract.store';
import { useVersionStore } from 'store/version.store';

import { useQueryGetBoardInit } from 'api/queries/getBoardInit.query';
import { useQueryGetSingleMilestoneFragnet } from 'api/queries/getSingleMilestoneFragnet.query';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import { CustomizeFilterOptions } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.utils';

export const useMainFiltersProvider = () => {
    const { project, contract } = useProjectTreeStore();
    const currentVersion = useVersionStore((state) => state.version);
    const latestVersionId = currentVersion?.id;
    const [activityFragnet] = useQueryState('activityFragnet');
    const [activityForwardFragnet] = useQueryState('activityForwardFragnet');
    const [customizeFilterOptions, setCustomizeFilterOptions] = useState(CustomizeFilterOptions);
    const [isCustomizeFilterOptionsInitialized, setIsCustomizeFilterOptionsInitialized] = useState(false);
    const activityFragnetSingle = useQueryGetSingleMilestoneFragnet({
        latestVersion: latestVersionId,
        taskVersionHashCode: activityFragnet,
    });

    const activityForwardFragnetSingle = useQueryGetSingleMilestoneFragnet({
        latestVersion: latestVersionId,
        taskVersionHashCode: activityForwardFragnet,
    });

    const boardInit = useQueryGetBoardInit({
        metaDataId: latestVersionId,
    });

    const assigneeOptions = useAssigneeOptionsList();

    const form = useForm<IFields>({
        defaultValues: {
            project: project?.id,
            contract: contract?.id,
            version: latestVersionId,
            cardActivity: null,
            assignee: null,
            status: null,
            riskIndicators: null,
            important: null,
            urgent: null,
            tags: null,
            cardSearch: '',
            flags: { isAdvancedTextSearch: false },
            finishDate: { value: [], type: 'TODAY_REF' },
            activityCodes: null,
            wbs: '',
            // Optional
            activityFragnet: null,
            activityForwardFragnet: null,
            cardType: null,
            completionPlanSegment: null,
            duration: null,
            float: null,
            hasAttachments: null,
            hasComments: { value: [], type: 'TODAY_REF' },
            lagLead: null,
            relatedActivity: '',
            resourceType: null,
            startDate: { value: [], type: 'TODAY_REF' },
            submittedCompletion: [0, 100],
            trackedActivity: null,
            updatedBy: null,
            commenter: null,
            mentioned: null,
            wbsLevel: [1, 10],
            resourceName: null,
            baselineStartDate: { value: [], type: 'TODAY_REF' },
            baselineEndDate: { value: [], type: 'TODAY_REF' },
            cluster: null,
        },
    });

    return {
        ui: {
            form,
            state: {
                customizeFilterOptions,
                isCustomizeFilterOptionsInitialized,
            },
            setters: {
                setCustomizeFilterOptions,
                setIsCustomizeFilterOptionsInitialized,
            },
        },
        api: {
            activityFragnetSingle,
            activityForwardFragnetSingle,
            boardInit,
            assigneeOptions,
            latestVersionId,
        },
    };
};
